import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	incomingDependencies: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.incoming-dependencies',
		defaultMessage:
			'{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> have incoming dependencies',
		description: 'Dependency count label. Appears on the dependency tooltip.',
	},
	singleIncomingDependency: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.single-incoming-dependency',
		defaultMessage:
			'{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> has an incoming dependency',
		description: 'Dependency count label. Appears on the dependency tooltip.',
	},
	outgoingDependencies: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.outgoing-dependencies',
		defaultMessage:
			'{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> have outgoing dependencies',
		description: 'Dependency count label. Appears on the dependency tooltip.',
	},
	singleOutgoingDependency: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.single-outgoing-dependency',
		defaultMessage:
			'{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> has an outgoing dependency',
		description: 'Dependency count label. Appears on the dependency tooltip.',
	},
	incomingDependenciesIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.incoming-dependencies-issue-term-refresh',
		defaultMessage:
			'{count} child {count, plural, one {work item} other {work items}} of <b>{itemKey} {title}</b> have incoming dependencies',
		description: 'Dependency count label. Appears on the dependency tooltip.',
	},
	singleIncomingDependencyIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.single-incoming-dependency-issue-term-refresh',
		defaultMessage:
			'{count} child {count, plural, one {work item} other {work items}} of <b>{itemKey} {title}</b> has an incoming dependency',
		description: 'Dependency count label. Appears on the dependency tooltip.',
	},
	outgoingDependenciesIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.outgoing-dependencies-issue-term-refresh',
		defaultMessage:
			'{count} child {count, plural, one {work item} other {work items}} of <b>{itemKey} {title}</b> have outgoing dependencies',
		description: 'Dependency count label. Appears on the dependency tooltip.',
	},
	singleOutgoingDependencyIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.single-outgoing-dependency-issue-term-refresh',
		defaultMessage:
			'{count} child {count, plural, one {work item} other {work items}} of <b>{itemKey} {title}</b> has an outgoing dependency',
		description: 'Dependency count label. Appears on the dependency tooltip.',
	},
});
